import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { useHistory } from 'react-router-dom';
import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const RedirectToMarketingPlusButton = ({
  trackingSource,
  size
}) => {
  const history = useHistory();
  const handleClick = () => {
    trackClickedLink({
      type: 'internal',
      url: '/marketing-plus',
      trackingSource,
      value: getI18nText('pricingPage.pricingCtas.goToBundlePage', {
        locale: 'en-us'
      })
    });
    history.push('/marketing-plus');
  };
  return /*#__PURE__*/_jsx(Button, {
    "data-selenium-id": `${trackingSource}-go-to-suite-page-button`,
    onClick: handleClick,
    block: true,
    size: size,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pricingCtas.goToBundlePage"
    })
  });
};
export default RedirectToMarketingPlusButton;